<form [formGroup]="form">
    <h1 mat-dialog-title>Observaciones de la entrega</h1>
    <div mat-dialog-content>
        <mat-spinner *ngIf="loading"></mat-spinner>
        <mat-form-field *ngIf="!loading" class="full-width">
            <input type="text" matInput placeholder="Usuario entrega" formControlName="UserFullName">
        </mat-form-field>
        <mat-form-field *ngIf="!loading" class="full-width">
            <textarea class="full-width" matInput formControlName="DeliveryObservation" placeholder="Observaciones entrega"></textarea>
        </mat-form-field>
    </div>
    <div class="clearfix">
        <div *ngIf="!loading" class="pull-right">
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
        </div>
    </div>
</form>